import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Modal } from "antd";
import VehicleTypeSelect from "../../components/VehicleTypeSelect";
const VehicleTypePickerModal = ({ open, tenantId, performsCustomerDeliveries, marketplaceParticipator, salesOrderApplicableTenantId, onSelect, onCancel }) => {
    const [selectedVehicleType, setSelectedVehicleType] = useState(undefined);
    const onOkClicked = () => {
        selectedVehicleType && onSelect(selectedVehicleType);
    };
    return (_jsx(Modal, { onCancel: onCancel, onOk: onOkClicked, open: open, title: "Choose a Vehicle Type", destroyOnHidden: true, children: _jsx(VehicleTypeSelect, { style: { width: '100%' }, tenantId: tenantId, performsCustomerDeliveries: performsCustomerDeliveries, marketplaceParticipator: marketplaceParticipator, salesOrderApplicableTenantId: salesOrderApplicableTenantId, onVehicleTypeChanged: setSelectedVehicleType }) }));
};
export default VehicleTypePickerModal;
